import Alert from '@mui/lab/Alert';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { ArrayInputProps, BooleanInput, TextInput, useResourceContext, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import FileManagerModalInput from '../FileManagerModalInput';
import TinyMCEInput from '../TinyMCEInput';
import ArrayContact from './ArrayContact';
import ArrayDevelopment from './ArrayDevelopment';
import ArrayDownload from './ArrayDownload';
import ArrayENewsletter from './ArrayENewsletter';
import ArrayFinancialReport from './ArrayFinancialReport';
import ArrayForm from './ArrayForm';
import ArrayHospitalVisitService from './ArrayHospitalVisitService';
import ArrayInnerSensations from './ArrayInnerSensations';
import ArrayLifeEducationProgrammeIntroduction from './ArrayLifeEducationProgrammeIntroduction';
import ArrayLink from './ArrayLink';
import ArraySharingCaption from './ArraySharingItem';
import ArraySharingNameDescription from './ArraySharingNameDescription';
import ArrayTitleContent from './ArrayTitleContent';
import BoundedInput from './BoundedInput';
import DonationFooter from './DonationFooter';

const BLOCKS_TYPE_ARRAY = [
  "html", "image", "page_title", "section_title", 
  "video_box", "youtube", "image_gallery",
  "array_download", "array_contact", "array_development", "array_title_content", 
  "array_sharing_caption", "array_sharing_name_description", "array_hospital_visit_service", "array_e_newsletter", 
  "array_inner_sensations", "array_life_education_programme_introduction", "array_link", "array_financial_report", 
  "button_volunteer", "donation_footer",
] as const;

export type BLOCK_TYPE = typeof BLOCKS_TYPE_ARRAY[number];

export type BLOCK_CONFIG = { 
  content_type_data: BLOCK_TYPE,
  alias?: string,
  label?: string,
}

export interface BlocksInputProps extends Omit<ArrayInputProps, "children"> {
  label?: string;
  hideLabel?:boolean;
  source: string;
  config?: Array<BLOCK_CONFIG>;
  configSource?: string;
}

const BlocksInput = ({ ...props }: BlocksInputProps) => {
  const { label, hideLabel, source, config, configSource } = props;
  const translate = useTranslate();
  const resource = useResourceContext();
  // const { langs } = useContentLangContext();
  // const { blockTypes } = useBlockTypesContext();
  const { watch } = useFormContext();
  const theConfig: Array<BLOCK_CONFIG> = config ? config : (configSource ? watch(configSource) : []);

  console.log('BlocksInput', theConfig);
  if (!Array.isArray(theConfig)) {
    return <></>;
  }

  return (
    <>
      {!hideLabel && <FormControl>
        <InputLabel shrink sx={{ position: 'relative', top: '4px', left: '-12px', maxWidth: 'calc(133% - 32px)', }}>{label ?? translate(`resources.${resource}.fields.${source}`)}</InputLabel>
      </FormControl>}
      <div style={{ width: "100%" }}>
        {theConfig.map(({ content_type_data, alias }, index) => {
          const theSource = alias ? `${source}.${alias}` : `${source}.array_${index}`;
          const theIndex = alias ? `${alias}_${index}` : `array_${index}`;
          const commonProps = { key: theIndex, source: theSource, index };

          switch (content_type_data) {
            case "html":
              return <Box key={theIndex}>
                <Box><TinyMCEInput source={`${theSource}.html_en`} label="HTML Content EN" /></Box>
                <Box><TinyMCEInput source={`${theSource}.html_tc`} label="HTML Content TC" /></Box>
                <Box><TinyMCEInput source={`${theSource}.html_sc`} label="HTML Content SC" /></Box>
              </Box>
            case "image":
              return <FileManagerModalInput key={theIndex} source={`${theSource}.image`} hideLabel mode="image" />
            case "page_title":
              return <div style={{
                display: 'grid',
                gap: '0px',
                columnGap: '10px',
                gridTemplateAreas: `'name_en name_tc name_sc'`
              }}>
                <TextInput source={`${theSource}.page_title_en`} label="Page Title EN" fullWidth sx={{ gridArea: 'name_en' }} />
                <TextInput source={`${theSource}.page_title_tc`} label="Page Title TC" fullWidth sx={{ gridArea: 'name_tc' }} />
                <TextInput source={`${theSource}.page_title_sc`} label="Page Title SC" fullWidth sx={{ gridArea: 'name_sc' }} />
              </div>
            case "section_title":
              return <div style={{
                display: 'grid',
                gap: '0px',
                columnGap: '10px',
                gridTemplateAreas: `'name_en name_tc name_sc'`
              }}>
                <TextInput source={`${theSource}.section_title_en`} label="Section Title EN" fullWidth sx={{ gridArea: 'name_en' }} />
                <TextInput source={`${theSource}.section_title_tc`} label="Section Title TC" fullWidth sx={{ gridArea: 'name_tc' }} />
                <TextInput source={`${theSource}.section_title_sc`} label="Section Title SC" fullWidth sx={{ gridArea: 'name_sc' }} />
              </div>
            case "array_download":
              return <ArrayDownload {...commonProps} />;
            case "array_contact": return <ArrayContact {...commonProps} />
            case "array_development": return <ArrayDevelopment {...commonProps} />
            case "array_title_content": return <ArrayTitleContent {...commonProps} />
            case "array_sharing_caption": return <ArraySharingCaption {...commonProps} />
            case "array_sharing_name_description": return <ArraySharingNameDescription {...commonProps} />
            case "array_hospital_visit_service": return <ArrayHospitalVisitService {...commonProps} />
            case "array_e_newsletter": return <ArrayENewsletter {...commonProps} />
            case "array_inner_sensations": return <ArrayInnerSensations {...commonProps} />
            case "array_life_education_programme_introduction": return <ArrayLifeEducationProgrammeIntroduction {...commonProps} />
            case "array_link": return <ArrayLink {...commonProps} />
            case "array_financial_report": return <ArrayFinancialReport {...commonProps} />
            case "donation_footer": return <DonationFooter {...commonProps} />
            case "button_volunteer": return <>
              <BooleanInput source={`${theSource}.enable`} />
              <div style={{ display: 'flex', columnGap: '10px', }}>
                <TextInput source={`${theSource}.title_en`} label="Button Title EN" fullWidth />
                <TextInput source={`${theSource}.title_tc`} label="Button Title TC" fullWidth />
                <TextInput source={`${theSource}.title_sc`} label="Button Title SC" fullWidth />
              </div>
            </>
            case "image_gallery":
              return <ArrayForm {...commonProps}>
                <BoundedInput source={`file`} input={<FileManagerModalInput source={`dummy`} mode="image" hideLabel />} />
              </ArrayForm>
            case "video_box":
              return <>
                <FileManagerModalInput source={`${theSource}.video_cover_fm`} label="Youtube Cover Image" fullWidth mode="image" />
                <div style={{ display: 'flex', columnGap: '10px', }}>
                  <TextInput source={`${theSource}.youtube_url_en`} label="Youtube Url EN" fullWidth />
                  <TextInput source={`${theSource}.youtube_url_tc`} label="Youtube Url TC" fullWidth />
                  <TextInput source={`${theSource}.youtube_url_sc`} label="Youtube Url SC" fullWidth />
                </div>
              </>;
            case "youtube":
              return <div style={{ display: 'flex', columnGap: '10px', }}>
                <TextInput source={`${theSource}.youtube_embed_url_en`} label="Youtube Embed Url EN" fullWidth />
                <TextInput source={`${theSource}.youtube_embed_url_tc`} label="Youtube Embed Url TC" fullWidth />
                <TextInput source={`${theSource}.youtube_embed_url_sc`} label="Youtube Embed Url SC" fullWidth />
              </div>
            default:
              return <Alert severity="error">
                <h2>Content type under construction!</h2>
                <p>Type: <b>{content_type_data}</b></p>
              </Alert>
          }
        })}
      </div>
    </>
  );
}

export default BlocksInput;
